import styled from 'styled-components'

export const QuitGameConfirmationContainer = styled.div`
  display: flex;
  flex-direction: column;

  justify-items: center;
  align-content: center;
  gap: 1rem;
  padding: 1rem;
  text-align: center;
  > p {
    margin: 0.6rem 0 1.65rem 0;
    text-align: center;
  }
`

export const QuitGameConfirmationTitle = styled.h2`
  text-align: center;
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 0;
`

export const QuitGameConfirmationImage = styled.img`
  width: 100px;
  height: 100px;
  align-self: center;
  margin: 0.65rem;
`

export const QuitGameConfirmationCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-items: center;
  label {
    align-self: center;
  }
  div {
    margin: 0;
  }
`
